const FALLBACK_ERROR_MESSAGE =
  'An unexpected error occurred. Please try again.';

export const getErrorMessageTranslation = (
  error: Error,
  fallbackErrorMessage: string = FALLBACK_ERROR_MESSAGE,
): string => {
  if (
    error.message.includes(
      'A test user tries to create a contract with a non-test user',
    )
  ) {
    return 'This action cannot be completed because test accounts cannot interact with production accounts.';
  }

  return fallbackErrorMessage;
};
